import React, { useState } from 'react'
import { DataContext } from '../../helper/HelperOne';
import NavBar from '../nav_bar/Navbar';
import ProductwiseReportList from './ProductwiseReportList';

function ProductwiseReport() {
    const [searchUi, setSearchUi] = useState(true);
    const [searchData, setSearchData] = useState(null);

    return (
        <DataContext.Provider value={{searchUi, setSearchUi, searchData, setSearchData}}>
            <NavBar
                childrenPage={<ProductwiseReportList />}
                menuId={15}
            />
        </DataContext.Provider>
    );
}

export default ProductwiseReport